import { formGetAll, formGetAllGrouped, formDelete } from "@/api/form";

const state = {
    forms: null,
    pollen_workflow_forms: null,
    bunch_workflow_forms: null,
    formGrouped: null,
    createdFormInfo: null
};

const mutations = {
    SET_FORM_GROUPED: (state, data) => {
        state.formGrouped = data;
    },
    SET_CREATED_FORM: (state, data) => {
        state.createdFormInfo = data;
    },
    SET_FORMS: (state, data) => {
        state.forms = data;
    },
    SET_POLLEN_WORKFLOW_FORMS: (state, data) => {
        state.pollen_workflow_forms = data;
    },
    SET_BUNCH_WORKFLOW_FORMS: (state, data) => {
        state.bunch_workflow_forms = data;
    },
};

const actions = {
    async getFormGroupped({ commit }, params) {
        let res = await formGetAllGrouped(params);
        if (res) {
            commit("SET_FORM_GROUPED", res.items); 
        }
    },
    async getForms({ commit }, params) {
        let res = await formGetAll(params);
        if (res) {
            commit("SET_FORMS", res); 
        }
    },
    async getPollenWorkflowForms({ commit }, params) {
        let res = await formGetAll({ ...params, "FormCategoryCode": "POLLEN_WORKFLOW" });
        if (res) {
            commit("SET_POLLEN_WORKFLOW_FORMS", res); 
        }
    },
    async getBunchWorkflowForms({ commit }, params) {
        let res = await formGetAll({ ...params, "FormCategoryCode": "BUNCH_WORKFLOW" });
        if (res) {
            commit("SET_BUNCH_WORKFLOW_FORMS", res); 
        }
    },
    async setCreatedForm({ commit }, form) {
        commit("SET_CREATED_FORM", form); 
    },
    async deleteForm({ dispatch }, params) {
        let res = await formDelete(params);
        if (res) {
            EventBus.$emit("snackBar", {
                text: "Form Removed Succesfully",
                snackbarColor: "green darken-2"
            });

            switch (params.Category) {
            case "POLLEN_WORKFLOW": 
                dispatch("getPollenWorkflowForms");
                break;
            case "BUNCH_WORKFLOW": 
                dispatch("getBunchWorkflowForms");
                break;
            default:
                dispatch("getForms");
                break;
            }
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};




// WEBPACK FOOTER //
// ./src/vuex/modules/form_store.js